module.exports = __webpack_public_path__ + "img/b.dbad2aa5.png";